<template>
  <div>
    <Toast/>
    <div class="card">
      <Steps :model="items" :readonly="true"/>
    </div>
    <Card>
      <template #header>
      </template>
      <template #title>
        Dirección
      </template>
      <template v-slot:subtitle>
        Añadir punto de venta
      </template>
      <template #content>
        <div class="field">
          <!--         Estado-->
          <Dropdown v-model="selectedEstado" :options="estados"
                    optionLabel="testado" optionValue="id_estado"
                    placeholder="Seleccionar Estado" class="filterItem" :loading="loadingEstado"
                    :showClear="true"
                    style="width: 100%"
                    :onChange="refreshMunicipios"
                    :filter="true"/>
          <!--        Municipio-->
          <Dropdown v-model="selectedMunicipio" :options="municipios"
                    optionLabel="tmunicipio" optionValue="id_municipio"
                    placeholder="Seleccionar Municipio" class="filterItem" :loading="loadingMunicipio"
                    :showClear="true"
                    v-if="selectedEstado"
                    style="width: 100%"
                    :filter="true"/>
        </div>

      </template>
      <template #footer>
        <div class="grid grid-nogutter justify-content-between">
          <Button label="Anterior" @click="prevPage()" icon="pi pi-angle-left"/>
          <Button label="Siguiente"
                  @click="nextPage()"
                  icon="pi pi-angle-right"
                  iconPos="right"
                  :disabled="this.selectedMunicipio ? disabled : ''"/>
        </div>
      </template>
    </Card>

    <router-view v-slot="{Component}" @prevPage="prevPage($event)" @nextPage="nextPage($event)">
      <keep-alive>
        <component :is="Component"/>
      </keep-alive>
    </router-view>
  </div>
  <Toast/>
</template>

<script>
import MainService from "@/service/backend/MainService";
import generalMixin from "@/mixins/generalMixin";
import AgencyService from "@/service/backend/AgencyService";

export default {
  name: "Step3",
  mixins: [generalMixin],
  created() {
    this.mainService = new MainService;
    this.agencyService = new AgencyService;
    this.$primevue.config.locale.emptyMessage = "Buscando opciones...";
  },
  mounted() {
    this.refreshEstados();
    this.selectedEstado = this.$store.getters.getAgency.id_estado;
    this.refreshMunicipios();
    this.selectedMunicipio = this.$store.getters.getAgency.id_municipio;
  },
  data() {
    return {
      items: [
        {
          label: 'Nombre',
          to: '/agencias/agregar-1'
        },
        {
          label: 'Cadena de comercialización',
          to: '/agencias/agregar-2'
        },
        {
          label: 'Dirección',
          to: '/agencias/agregar-3'
        },
      ],
      selectedEstado: null,
      selectedMunicipio: null,
      estados: null,
      municipios: null,
      loadingEstado: false,
      loadingMunicipio: false,
      params: null,
      pageIndex: 1,
      idAgency: null,
    }
  },
  methods: {
    async refreshEstados() {
      this.municipios = null;
      this.estados = await this.mainService.getEstados();
    },
    async refreshMunicipios() {
      if (this.selectedEstado) {
        this.municipios = await this.mainService.getMunicipios({id_estado: this.selectedEstado});
      }
    },
    async createAgency() {
      const response = await this.agencyService.createAgency({
        tagencia: this.$store.getters.getAgency.agencyName,

        id_prestador: 100,
        id_comercializador: this.$store.getters.getAgency.id_comercializador ? this.$store.getters.getAgency.id_comercializador : this.$store.getters.getProfile.id_comercializador,
        id_banca: this.$store.getters.getAgency.id_banca ? this.$store.getters.getAgency.id_banca : this.$store.getters.getProfile.id_banca,
        id_distribuidor: this.$store.getters.getAgency.id_distribuidor ? this.$store.getters.getAgency.id_distribuidor : this.$store.getters.getProfile.id_distribuidor,

        id_estado: this.$store.getters.getAgency.id_estado,
        id_municipio: this.$store.getters.getAgency.id_municipio,

        trif_agencia: '',
        tcorreo_electronico: '',
      });
      if (response.error) {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: `No se pudo crear la agencia ${this.$store.getters.getAgency.agencyName}| ` + response.error,
          life: 10000
        });
        this.overlay = false;
        return false;
      } else {

        this.idAgency = await this.agencyService.fecthAgencyId({
          id_psxcmxbanxdisxagc: response[0].id_psxcmxbanxdisxagc,
        })
        this.$store.commit('setAgency', {
          agencyName: this.$store.getters.getAgency.agencyName,
          id_comercializador: this.$store.getters.getAgency.id_comercializador,
          id_banca: this.$store.getters.getAgency.id_banca,
          id_distribuidor: this.$store.getters.getAgency.id_distribuidor,
          id_estado: this.selectedEstado,
          id_municipio: this.selectedMunicipio,
          id_agencia: this.idAgency
        });
        return true;
      }
    },
    async nextPage() {
      this.$store.commit('setAgency', {
        agencyName: this.$store.getters.getAgency.agencyName,
        id_comercializador: this.$store.getters.getAgency.id_comercializador,
        id_banca: this.$store.getters.getAgency.id_banca,
        id_distribuidor: this.$store.getters.getAgency.id_distribuidor,
        id_estado: this.selectedEstado,
        id_municipio: this.selectedMunicipio,
        id_agencia: this.idAgency
      });
      if (await this.createAgency()) {
        this.$router.push({name: 'agencias',});
      }
    },
    prevPage() {
      this.$store.commit('setAgency', {
        agencyName: this.$store.getters.getAgency.agencyName,
        id_comercializador: this.$store.getters.getAgency.id_comercializador,
        id_banca: this.$store.getters.getAgency.id_banca,
        id_distribuidor: this.$store.getters.getAgency.id_distribuidor,
        id_estado: this.selectedEstado,
        id_municipio: this.selectedMunicipio,
        // id_agencia: this.idAgency
      });
      this.$router.push('/agencias/agregar-2');
    },
  }
}
</script>

<style scoped lang="scss">
.filterItem {
  margin: 20px 0 5px 0;
}

</style>